var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.9141 32L29.9141 32L29.9141 29L13.9141 29L13.9141 32ZM20.4611 15.4811L20.4611 26L23.3643 26L23.3643 15.4486L28.8281 20.9784L30.8281 19L21.9449 10L12.9992 19L14.9992 20.9784L20.4611 15.4811Z","fill":"black","key":1})]);
}

Share.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Share;

Share.default = Share;
